import {IconTooltip, Text, theme} from '@forecast-it/design-system';
import React from 'react';
import {RoleDropdownLabelFormat} from './RoleDropdown';
import {useIntl} from 'react-intl';
import styled from 'styled-components';
import {Label} from '../../../../my-work-tab/my-timesheets-page/bottom-section/timesheets-time-registration-table/advanced-time-registration-input/AdvancedTimeRegistrationStyled';
interface LabelAndWarningProps {
	showLabel?: boolean;
	labelFormat?: RoleDropdownLabelFormat;
	warningText?: JSX.Element | string;
	children: React.ReactNode;
}
export const LabelWarningContainer = styled.div<Pick<LabelAndWarningProps, 'labelFormat'>>`
	height: 11px; // to make this fit it with existing modals without changing all of them, we need to lock the height
	margin-bottom: ${p => (p.labelFormat === RoleDropdownLabelFormat.NO_MARGIN ? '0' : '6px')};
	overflow: visible;
	display: flex;
	gap: ${theme.spacing['100']};
	align-items: center;
`;

export function LabelAndWarning({showLabel, labelFormat, warningText, children}: LabelAndWarningProps): JSX.Element {
	const {formatMessage} = useIntl();

	return showLabel ? (
		<>
			<LabelWarningContainer labelFormat={labelFormat}>
				<Label>{formatMessage({id: 'common.role'})}</Label>
				{warningText ? (
					<IconTooltip icon={'warning'} iconSize={'s'} iconColor={'error'}>
						<Text size={'2'}>{warningText}</Text>
					</IconTooltip>
				) : null}
			</LabelWarningContainer>
			<div className="roles">{children}</div>
		</>
	) : (
		<>{children}</>
	);
}
